(function () {
  const MOBILE_MAX = 768;
  const SWIPE_THRESHOLD = 8;

  function isMobileSliderContext() {
    return window.matchMedia(`(max-width: ${MOBILE_MAX}px)`).matches;
  }

  function updateSliderDots(slider) {
    const dotsContainer = slider.parentElement && slider.parentElement.querySelector('.slider-dots');
    if (!dotsContainer) return;

    const dots = dotsContainer.querySelectorAll('.slider-dot');
    const width = slider.offsetWidth || 1;
    const activeIndex = Math.round(slider.scrollLeft / width);

    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === activeIndex);
    });
  }

  function bindSwipeClickGuard(slider) {
    const clickTargets = [];
    const cardMedia = slider.closest('.card__media');
    const cardInner = slider.closest('.card__inner');

    if (cardMedia) clickTargets.push(cardMedia);
    if (cardInner) clickTargets.push(cardInner);

    let touchStartX = 0;
    let touchStartY = 0;
    let didSwipe = false;

    slider.addEventListener(
      'touchstart',
      (e) => {
        if (!isMobileSliderContext() || e.touches.length !== 1) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        didSwipe = false;
      },
      { passive: true }
    );

    slider.addEventListener(
      'touchmove',
      (e) => {
        if (!isMobileSliderContext() || e.touches.length !== 1) return;
        const dx = Math.abs(e.touches[0].clientX - touchStartX);
        const dy = Math.abs(e.touches[0].clientY - touchStartY);
        if (dx > SWIPE_THRESHOLD && dx > dy) {
          didSwipe = true;
        }
      },
      { passive: true }
    );

    clickTargets.forEach((target) => {
      target.addEventListener(
        'click',
        (e) => {
          if (didSwipe) {
            e.preventDefault();
            e.stopPropagation();
            didSwipe = false;
          }
        },
        true
      );
    });
  }

  function initSlider(slider) {
    if (slider.dataset.sliderInit === 'true') return;

    const images = slider.querySelectorAll('img');
    if (images.length < 2) return;

    slider.dataset.sliderInit = 'true';

    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;
    let isDragging = false;

    const parentLink = slider.closest('.card__inner') || slider.closest('.card__media') || slider;

    slider.addEventListener('mousedown', (e) => {
      if (!isMobileSliderContext()) return;
      isDown = true;
      isDragging = false;
      slider.style.cursor = 'grabbing';
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.style.cursor = '';
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.style.cursor = '';
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown || !isMobileSliderContext()) return;
      e.preventDefault();
      isDragging = true;
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2;
      slider.scrollLeft = scrollLeft - walk;
    });

    slider.addEventListener(
      'scroll',
      () => {
        updateSliderDots(slider);
      },
      { passive: true }
    );

    if (parentLink) {
      parentLink.addEventListener(
        'click',
        (e) => {
          if (isDragging) {
            e.preventDefault();
            e.stopPropagation();
            isDragging = false;
          }
        },
        true
      );
    }

    bindSwipeClickGuard(slider);
    updateSliderDots(slider);
  }

  function initCardProductSliders(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.card-product-slider').forEach(initSlider);
  }

  function buildCardProductSliderMediaHtml(options) {
    const {
      mainSrc,
      hoverSrc = '',
      alt = '',
      productUrl = '#',
      hoverEnabled = true,
    } = options;
    const hasSecondImage = Boolean(hoverSrc && hoverSrc !== mainSrc);
    const dotsHtml = hasSecondImage
      ? '<div class="slider-dots" aria-hidden="true"><span class="slider-dot active"></span><span class="slider-dot"></span></div>'
      : '';
    const hoverClass = hoverEnabled ? ' card-product-slider--hover-enabled' : '';
    const hoverImgHtml = hasSecondImage
      ? `<img src="${hoverSrc}" alt="" loading="lazy" class="motion-reduce main_product_hover_img" width="900" height="900" />`
      : '';

    return `<div class="card__media product__imgs_updates" style="position:relative;cursor:pointer;" onclick="location.href='${productUrl}';">
      ${dotsHtml}
      <div class="card-product-slider${hoverClass} media media--transparent media--hover-effect">
        <img src="${mainSrc}" alt="${alt}" loading="lazy" class="motion-reduce main_product_img" width="900" height="900" />
        ${hoverImgHtml}
      </div>
    </div>`;
  }

  window.initCardProductSliders = initCardProductSliders;
  window.buildCardProductSliderMediaHtml = buildCardProductSliderMediaHtml;

  document.addEventListener('DOMContentLoaded', () => {
    initCardProductSliders(document);
  });
})();
